import type { LineItemFragment } from "@commerce-frontend/types";
import { useTranslations } from "next-intl";
import Image from "next/image";

type Props = {
	lineItems: LineItemFragment[];
};

export const LineItemsOverview = ({ lineItems }: Props) => {
	const t = useTranslations("LineItemsOverview");

	return (
		<div className="w-full grow bg-white">
			{lineItems.map((lineItem, index) => (
				<article key={index} className="flex gap-md">
					<picture className="aspect-square w-24 shrink-0 overflow-hidden rounded-lg">
						{lineItem.variant.primaryImage ? (
							<Image
								src={lineItem.variant.primaryImage.url}
								alt={lineItem.variant.primaryImage.alt ?? lineItem.variant.name ?? ""}
								width="96"
								height="96"
								sizes="96px"
								className="aspect-square w-full"
							/>
						) : undefined}
					</picture>

					<div className="flex flex-1 flex-col">
						<div className="mb-sm line-clamp-2 text-sm font-medium">{lineItem.productName}</div>
						{lineItem.variant?.color && (
							<div className="text-sm text-gray-600">
								<span className="lowercase">{t("color")}</span>: {lineItem.variant.color}
							</div>
						)}
						{lineItem.variant?.size && (
							<div className="text-sm text-gray-600">
								<span className="lowercase">{t("size")}</span>: {lineItem.variant.size}
							</div>
						)}
						<div className="text-sm font-semibold text-gray-600">
							<span className="lowercase">{t("items")}</span>: {lineItem?.quantity}
						</div>
					</div>
				</article>
			))}
		</div>
	);
};
